export default "https://cdn-static.gokick.com/assets/31bbee86f9627d9d8b331552e0c9ca66f3d2b554/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";